import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import Educations from "../../containers/education/Educations";
import Certifications from "../../containers/certifications/Certifications";
import EducationImg from "./EducationImg";
import "./EducationComponent.css";
import { Fade } from "react-reveal";

function Education(props) {
  const theme = props.theme;
  return (
    <div className="education-main">
      <Header theme={props.theme} setTheme={props.setTheme} />
      <div className="basic-education">
        <Fade bottom duration={2000} distance="40px">
          <div className="heading-div">
            <div className="heading-img-div">
              <EducationImg theme={theme} />
            </div>
            <div className="heading-text-div">
              <h1 className="heading-text" style={{ color: theme.text }}>
                Education
              </h1>
              <h3 className="heading-sub-text" style={{ color: theme.text }}>
                Degrees and Certifications
              </h3>
              <p
                className="experience-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                Welcome to my personal website, which highlights my education
                ,research and development projects as well as my personal
                hobbies.
              </p>
              <p
                className="experience-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                In Computer Science Domain, My broad area of interest lies in
                the fields of ML, NLP and their far reaching applications in
                Healthcare. I'm interested in developing both front-end and
                back-end code in order to construct full-stack user apps.
              </p>
              <p
                className="experience-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                I love to solve challenges and always eager to learn something
                new be it online courses or life necessities like cooking. I
                actively participate in hackathons and other tech-related
                activities. My Detailed CV can be found{" "}
                <a href="https://drive.google.com/file/d/1mkKfrqQ_mCxJnjLnvBeyPtEhR1p4LW56/view?usp=drive_link">
                  Here
                </a>
                .
              </p>
            </div>
          </div>
        </Fade>
        <Educations theme={props.theme} />
        <Certifications theme={props.theme} />
      </div>
      <Footer theme={props.theme} />
    </div>
  );
}

export default Education;
